import { App } from 'vue'
import KButton from './src/button.vue'

KButton.install = (app: App): void => {
  app.component(KButton.name, KButton)
}

export default KButton
